﻿import React from 'react';
import { EpiContext } from '../../Shared/Scripts/Store/EpiContext/Types';
import VeilederIasDto from '../Models/VeilederIasDto';
import { connect } from 'react-redux';
import { VeilederIasAppState } from '../Store';
import { toggleVilkar } from '../Store/Valg/Actions';
import contentResolver, { resolveRawText } from '../../Shared/Scripts/Utilities/EpiContentResolver';
import { ModalCompontent } from '../../Shared/Scripts/Components/ModalComponent';
import { updateZIndex } from '../../Shared/Scripts/Store/EpiContext/Actions';
import { BoksResultat } from '../../VeilederInntektsavhengigStipend/Ids';
import { ArticleContentComponent } from '../../Shared/Scripts/Components/ArticleContentComponent';
import * as ValgTypes from '../Store/Valg/Types';
import { updateLiveMessage } from '../../Shared/Scripts/Utilities/LiveMessage';

interface ResultOwnProps {
    valg: ValgTypes.ValgState;
    eventId: string | null;
}

type ResultatProps = MapStateToProps & MapDispatchToProps & ResultOwnProps;

class ResultatComponent extends React.PureComponent<ResultatProps> {
    constructor(props: ResultatProps) {
        super(props);
        this.onVilkarClick = this.onVilkarClick.bind(this);
        this.onRequestClose = this.onRequestClose.bind(this);
    }

    componentDidMount(): void {
        updateLiveMessage();
    }

    onRequestClose(): void {
        this.props.updateZIndex(1);
        this.props.toggleVilkar();
    }

    onVilkarClick(event: React.MouseEvent): void {
        this.props.updateZIndex(2);
        this.props.toggleVilkar();
    }

    render(): JSX.Element {
        const { visVilkar, epiContext, eventId } = this.props;

        return (
            <div
                id={BoksResultat}
                className="c-veileder__panel c-veileder__panel--resultat c-veileder__panel--aubergine"
            >
                <div className="c-veileder__panel-row">
                    <div className="c-veileder__content c-veileder__content--header">
                        <h3 className="c-veileder__tittel c-veileder__tittel--resultat">
                            {contentResolver(epiContext, 'overskriftResultat')}
                        </h3>
                    </div>
                    <div className="c-veileder__content">
                        <div className="c-veileder__content--textarea">
                            {contentResolver(epiContext, 'infoResultat')}
                        </div>
                    </div>
                </div>
                <div className="c-veileder__panel-row">
                    <div className="c-veileder__content c-veileder__content--linkarea c-veileder__content--footer">
                        <button type="button" className="c-knapp c-knapp--lenke" onClick={this.onVilkarClick}>
                            {contentResolver(epiContext, 'resultatLenketekst')}
                        </button>
                        <ModalCompontent
                            isOpen={visVilkar}
                            onRequestClose={this.onRequestClose}
                            ariaCloseText={resolveRawText(epiContext, 'ariaLabelResultatModal')}
                            eventId={eventId}
                        >
                            <ArticleContentComponent
                                headerinnhold={contentResolver(epiContext, 'overskriftResultatModal', 2)}
                                contentinnhold={contentResolver(epiContext, 'contentResultatModal', 2)}
                            />
                        </ModalCompontent>
                    </div>
                    <div className="c-veileder__content" />
                </div>
            </div>
        );
    }
}

interface MapStateToProps {
    epiContext: EpiContext<VeilederIasDto>;
    visVilkar: boolean;
}

interface MapDispatchToProps {
    toggleVilkar: typeof toggleVilkar;
    updateZIndex: typeof updateZIndex;
}

export default connect(
    (state: VeilederIasAppState): MapStateToProps => {
        return {
            epiContext: state.epiContext,
            visVilkar: state.valg.visVilkar,
        };
    },
    { toggleVilkar, updateZIndex },
)(ResultatComponent);
